<template>
<div class="container-fluid" id="customers">
  <div class="container customers">
    <h2 class="h2 section-title underline">OUR CUSTOMERS</h2>

    <div class="carousel">

      <button class="arrow left" @click="moveLeft">‹</button>

      <div class="carousel-wrapper">
        <div 
          class="carousel-track"
          :style="{ transform: `translateX(${translateX}px)` }"
        >
          <div 
            class="imagem"
            v-for="(img, i) in imagensDuplicadas"
            :key="i"
          >
            <img :src="img" alt="">
          </div>
        </div>
      </div>

      <button class="arrow right" @click="moveRight">›</button>

    </div>

  </div>
</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const imagens = [
  '/img/cliente/standard.png',
  '/img/cliente/bic.png',
  '/img/cliente/sol.png',
  '/img/cliente/bni.png',
  '/img/cliente/bcs.png',
  '/img/cliente/bci.png',
  '/img/cliente/nossa.png',
  '/img/cliente/alianca.png',
  '/img/cliente/asan.png',
  '/img/cliente/ensa.png'
]

// duplicamos para criar efeito infinito contínuo
const imagensDuplicadas = [...imagens, ...imagens]

const translateX = ref(0)
let speed = 0.5
let animationFrame

const animate = () => {
  translateX.value -= speed

  // quando chega no meio, reinicia suavemente
  if (Math.abs(translateX.value) >= (imagens.length * 220)) {
    translateX.value = 0
  }

  animationFrame = requestAnimationFrame(animate)
}

onMounted(() => {
  animate()
})

onUnmounted(() => {
  cancelAnimationFrame(animationFrame)
})

const moveRight = () => {
  translateX.value -= 100
}

const moveLeft = () => {
  translateX.value += 100
}
</script>

<style scoped>

.container-fluid{
  background-color: #fef6f2;
}

.container {
  margin-top: 5%;
  padding: 5%;
}

.carousel {
  position: relative;
  display: flex;
  align-items: center;
}

.carousel-wrapper {
  overflow: hidden;
  width: 100%;
}

.carousel-track {
  display: flex;
}

.imagem {
  min-width: 300px;
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imagem img {
  width: 100%;
  max-width: 250px;
}

.arrow {
  background: var(--title-color);
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 22px;
  z-index: 2;
  font-weight: bold;
}

.arrow:hover {
  background: #333;
}

</style>
